import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import UiContext from "../../../store/ui-context";
import AppContext from "../../../store/app-context";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import SearchInputText from "../components/SearchInputText";
import TokoBox from "../components/TokoBox";
import { Button } from "primereact/button";

const ListTokoPage = () => {
  const appContext = useContext(AppContext);
  const uiContext = useContext(UiContext);
  const { requestGet } = useAPIRequest();
  const [loading, setLoading] = useState(false);

  const [filterText, setFilterText] = useState("");
  const [listToko, setListToko] = useState([]);

  const [paging, setPaging] = useState({
    page: 1,
    take: 20,
    filter: "",
    total: 0,
  });

  // use effect section

  useEffect(() => {
    if (appContext.selectedKota) {
      fetchListToko(paging, true);
    }
  }, [appContext.selectedKota]);

  // api call section

  const fetchListToko = async (_paging, reset) => {
    const _newPaging = _paging || paging;
    if (reset) {
      _newPaging.page = 1;
    }

    const selectedKota = appContext.selectedKota;
    const filterArr = [];
    if (selectedKota) {
      filterArr.push(`kota_id:=:${selectedKota.id}`);
    }
    const _filterText = filterText.toLowerCase();
    if (_filterText && _filterText.length > 0) {
      filterArr.push(`nama_toko:contains:${_filterText}`);
    }

    const _filter = filterArr.join(";");

    return requestGet({
      fullUrl: `/api/masterdata/toko/data`,
      params: {
        page: _newPaging.page,
        take: _newPaging.take,
        filter: _filter,
        order: "nama_toko",
        order_method: "ASC",
      },
      onSuccess: ({ pagination, message, data }) => {
        if (reset) {
          setListToko(data);
        } else {
          setListToko([...listToko, ...data]);
        }
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // ui handler section
  const handleSearch = (filterText) => {
    fetchListToko(paging, true);
  };

  const handleOnClickedLoadMore = () => {
    const _paging = { ...paging, page: paging.page + 1 };
    setPaging(_paging);
    fetchListToko(_paging, false);
  };

  // custom ui section

  return (
    <div className="col-start-start gap-1">
      <div className="col-start-start bg-white w-full shadow-xs px-3 sm:px-5 pt-2 pb-6">
        <div className="row-start-center gap-2 py-4">
          <Link className="px-1" to={-1}>
            <i className="pi pi-arrow-left text-slate-600 text-[0.8rem]" />
          </Link>
          <span className="text-slate-700 text-xl leading-none">Toko</span>
        </div>

        <div className="col-center-center w-full pb-2">
          <div className="row-between-center w-full bg-stone-100 py-1 pl-2 pr-1 rounded">
            <span className="text-slate-500 min-w-[9rem]">
              Pilih Lokasi Anda
            </span>

            <Dropdown
              className="border-slate-300 w-full"
              value={appContext.selectedKota}
              onChange={(e) => appContext.setSelectedKota(e.value)}
              options={appContext.listKota}
              optionLabel="nama"
              placeholder="Pilih Kota"
              checkmark={true}
              highlightOnSelect={false}
              pt={{
                input: { className: "text-sm text-slate-500 font-semibold" },
              }}
            />
          </div>
        </div>

        <SearchInputText
          loading={loading}
          value={filterText}
          autofocus={false}
          placeholder={`Find In Toko`}
          onChange={(_text) => setFilterText(_text)}
          onSearch={(text) => handleSearch(text)}
        />
      </div>

      <div className="row-start-start bg-white w-full shadow-xs flex-wrap px-3 sm:px-5 py-4 gap-4">
        {listToko.map((toko) => (
          <TokoBox key={toko.id} toko={toko} />
        ))}
      </div>

      <div className="row-center-center py-2 w-full">
        <Button
          className="opacity-80"
          icon="pi pi-sort-down-fill"
          label="Load more"
          loading={loading}
          // outlined
          rounded
          onClick={() => {
            handleOnClickedLoadMore();
          }}
        />
      </div>
    </div>
  );
};

export default ListTokoPage;
